export enum BookingFormFieldType {
  Text = 'Text',
  TextArea = 'TextArea',
  Number = 'Number',
  Select = 'Select',
  Radio = 'Radio',
  Checkbox = 'Checkbox'
}

export interface IBookingFormField {
  id: string;
  label: string;
  type: BookingFormFieldType;
  required: boolean;
  min?: number | null;
  max?: number | null;
  options: string[];
}

export interface IBookingFormAnswer {
  fieldId: string;
  label?: string;
  type: BookingFormFieldType;
  value?: string | null;
}
